import {forEach} from "../helpers";

export function changeCity() {
  forEach(document.querySelectorAll('.js-change-city'), select => {
    select.addEventListener('change', () => {
      location.search = 'location='+select.value;
    });
  });
}
